// ! NOT MIGRATED
import React from 'react';
export const HorizontalSeparator = () => (
  <div data-testid='horizontal-separator' className='border-t border-evolve-highlight' />
);
